import React from 'react';
import { PrimaryButton } from 'src/shared/components/button/Button';
import WarningMessage from 'src/shared/components/warning-message/WarningMessage';
import styles from '../EditProjectUser.module.scss';

type EditProjectUserActivatePanelProps = {
    /** True when user is Active or Invited (deactivate path); false when inactive (reactivate path) */
    isActiveOrInvited: boolean;
    activeStatusText: string;
    activeStatusIcon: React.ReactNode;
    isSubmitting: boolean;
    userSummary: React.ReactNode;
    statusIndicator: React.ReactNode;
    notifyCheckbox: React.ReactNode;
    backButton: React.ReactNode;
    onConfirmActivationChange: () => void;
};

/** Confirmation UI for `editUserView === 'activate-or-deactivate'` */
const EditProjectUserActivatePanel = ({
    isActiveOrInvited,
    activeStatusText,
    activeStatusIcon,
    isSubmitting,
    userSummary,
    statusIndicator,
    notifyCheckbox,
    backButton,
    onConfirmActivationChange,
}: EditProjectUserActivatePanelProps) => (
    <>
        <div className={styles.mainText}>Are you sure you want to {activeStatusText.toLowerCase()} the following user?</div>

        {userSummary}
        <div className={styles.subHeader}>{statusIndicator}</div>
        <span className={styles.sectionDivider}></span>
        <WarningMessage
            message={
                <>
                    This user will {isActiveOrInvited ? 'lose' : 'regain'} access to the NatureMetrics platform and their assigned sites{' '}
                    <br />
                    <br />
                    You can {isActiveOrInvited ? 'reactivate' : 'deactivate'} this user at a later time
                </>
            }
        />

        <div>{notifyCheckbox}</div>

        <div className={`${styles.bottomNavigation} ${styles['bottomNavigationRow']}`}>
            <div>{backButton}</div>
            <div>
                <PrimaryButton onClick={onConfirmActivationChange} disabled={isSubmitting}>
                    {activeStatusIcon}&nbsp;{isSubmitting ? 'Processing...' : activeStatusText}
                </PrimaryButton>
            </div>
        </div>
    </>
);

export default EditProjectUserActivatePanel;
